import React, {useState} from "react";
import "./LegalPages.css";
import {isOptedOut, setOptOut} from "../analytics";

function goToConfidentialite() {
    window.history.pushState({}, "", "/confidentialite");
    window.dispatchEvent(new PopStateEvent("popstate"));
}

export default function MentionsPage({onBack}) {
    const [optedOut, setOptedOut] = useState(isOptedOut);

    function toggleOptOut() {
        setOptOut(!optedOut);
        setOptedOut(!optedOut);
    }

    return (
        <div className="legal-page">
            <div className="legal-wrapper">
                {onBack && (
                    <button className="legal-btn-back" onClick={onBack}>← Retour à la page d'accueil</button>
                )}

                <h1 className="legal-title">Mentions légales</h1>

                <h2 className="legal-section-title">Éditeur du site</h2>
                <p className="legal-paragraph">
                    Paroles d'Agents est édité par le SAPPM (Syndicat Autonome des Personnels des Services du Premier Ministre), organisation syndicale de la fonction publique.
                </p>
                <ul className="legal-list">
                    <li>Adresse : 20 avenue de Ségur, 75007 Paris</li>
                    <li>Contact : sappm@pm.gouv.fr</li>
                    <li>Directeur de la publication : Christian ALBENQUE, secrétaire général du SAPPM</li>
                    <li>Directeur de la publication délégué : Marc MISSUD, secrétaire général délégué du SAPPM</li>
                </ul>

                <h2 className="legal-section-title">Hébergement</h2>
                <p className="legal-paragraph">Gandi SAS — 63-65 boulevard Masséna, 75013 Paris.</p>

                <h2 className="legal-section-title">Propriété intellectuelle</h2>
                <p className="legal-paragraph">
                    L'ensemble des contenus du site (textes, graphismes, logo) est la propriété du SAPPM, sauf mention contraire. Toute reproduction sans autorisation est interdite.
                </p>

                <h2 className="legal-section-title">Données personnelles</h2>
                <p className="legal-paragraph">
                    Voir la rubrique dédiée{" "}
                    <button className="legal-link-internal" onClick={goToConfidentialite}>Confidentialité &amp; RGPD</button>.
                </p>

                <h2 className="legal-section-title">Cookies</h2>
                <p className="legal-paragraph">
                    Ce site n'utilise pas de cookies de suivi ni de publicité. L'authentification repose sur un stockage local de votre navigateur (localStorage), pas sur des cookies.
                </p>

                <h2 className="legal-section-title">Mesure d'audience</h2>
                <p className="legal-paragraph">
                    L'audience du site est mesurée de façon anonyme avec Matomo, sans cookie et sans identification des personnes. Le réglage « Ne pas suivre » de votre navigateur est respecté. Seuls sont comptés les pages consultées, les démarrages et fins de tests et les inscriptions, jamais vos réponses ni vos résultats.
                </p>
                <p className="legal-paragraph">
                    <strong>Pages de campagne.</strong> Les pages d'information et de sensibilisation diffusées pendant une durée limitée (adresses commençant par « /campagne/ ») sont également comptées avec Matomo, selon les mêmes principes : aucun cookie, aucune identification des personnes, et le réglage « Ne pas suivre » de votre navigateur est respecté, de sorte que votre visite n'est alors pas comptée. Seuls sont recueillis la page consultée (sans les éléments qui suivent le « ? » ou le « # » de l'adresse), la date de la visite et des données techniques agrégées.
                </p>
                <p className="legal-paragraph">
                    Le bouton « Refuser le suivi » ci-dessous s'applique au site Paroles d'Agents. Ces pages de campagne sont hébergées de façon isolée et ne le lisent pas : si vous souhaitez ne pas être comptée ou compté, activez le réglage « Ne pas suivre » de votre navigateur. Les données de mesure sont conservées 24 mois au maximum.
                </p>
                <p className="legal-paragraph">
                    {optedOut
                        ? "Vous avez refusé le suivi : votre visite n'est pas comptée. "
                        : "Vous pouvez refuser ce suivi à tout moment : "}
                    <button className="legal-link-internal" onClick={toggleOptOut}>
                        {optedOut ? "Accepter à nouveau le suivi" : "Refuser le suivi"}
                    </button>
                    .
                </p>
            </div>
        </div>
    );
}
